// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2619) return "static/chunks/2619-9932300caa5ff521.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"195":"b005a91831a7ed8b","2750":"61ab924f7d383bee","4240":"b00a268fb717ef00","4635":"46fb81d978d0014c","4675":"8ffc385614c2c968","5499":"17f8c91ab44b8d61","6395":"2414882bb1fec0a5","7056":"0102e828b25e001f","8593":"c5b4a056d7e60b3e"}[chunkId] + ".js";
};